var d = Object.defineProperty, f = Object.defineProperties;
var x = Object.getOwnPropertyDescriptors;
var _ = Object.getOwnPropertySymbols;
var P = Object.prototype.hasOwnProperty, v = Object.prototype.propertyIsEnumerable;
var p = (s, r, e) => r in s ? d(s, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[r] = e, u = (s, r) => {
  for (var e in r || (r = {}))
    P.call(r, e) && p(s, e, r[e]);
  if (_)
    for (var e of _(r))
      v.call(r, e) && p(s, e, r[e]);
  return s;
}, h = (s, r) => f(s, x(r));
var l = (s, r, e) => new Promise((o, t) => {
  var i = (n) => {
    try {
      c(e.next(n));
    } catch (m) {
      t(m);
    }
  }, a = (n) => {
    try {
      c(e.throw(n));
    } catch (m) {
      t(m);
    }
  }, c = (n) => n.done ? o(n.value) : Promise.resolve(n.value).then(i, a);
  c((e = e.apply(s, r)).next());
});
function w(s) {
  if (s == null) return null;
  const r = Array.isArray(s) ? s : s.split(",");
  return new Set(r.map((e) => e.trim()).filter(Boolean));
}
const y = "core";
function b(s, r) {
  return r === null || s === y ? !0 : r.has(s);
}
function E(s) {
  var e;
  const { teacherTotter: r } = s.providers;
  if (r != null && r.enabled && !r.syncUrl)
    throw new Error("[analytics] teacher-totter is enabled but no syncUrl was provided.");
  return {
    app: s.app,
    environment: s.environment,
    providers: s.providers,
    enabledGroups: w(s.enabledFeatureGroups),
    events: s.events,
    debug: (e = s.debug) != null ? e : !1
  };
}
const k = {
  posthog: "posthog",
  "teacher-totter": "teacherTotter"
};
class G {
  constructor(r, e) {
    this.config = r, this.providers = e, this.commonProps = {
      mx_app: r.app,
      mx_env: r.environment,
      mx_locale: "",
      mx_country_code: "",
      mx_user_profile_id: "",
      mx_user_profile_type: "unknown",
      mx_market_region_id: "",
      mx_school_id: "",
      mx_one_roster_user_id: ""
    }, this.runProviders((o) => o.init());
  }
  setCommonProps(r) {
    this.commonProps = {
      mx_app: this.config.app,
      mx_env: this.config.environment,
      mx_locale: r.locale,
      mx_country_code: r.countryCode,
      mx_user_profile_id: r.userProfileId,
      mx_user_profile_type: r.userProfileType,
      mx_market_region_id: r.marketRegionId,
      mx_school_id: r.schoolId,
      mx_one_roster_user_id: r.oneRosterUserId
    }, this.runProviders((e) => e.setCommonProps(this.commonProps));
  }
  identify() {
    const r = this.commonProps.mx_user_profile_id;
    this.runProviders((e) => e.identify(r, this.commonProps));
  }
  track(r, e, o) {
    return l(this, null, function* () {
      const t = this.config.events[r];
      if (!t) {
        this.config.debug && console.warn(`[analytics] Unknown event "${r}" not in the event map; skipping.`);
        return;
      }
      const i = {
        name: r,
        group: t.group,
        props: e,
        commonProps: this.commonProps
      };
      yield Promise.all(
        this.providers.map((a) => l(this, null, function* () {
          if (!(a.isGroupGated && !b(i.group, this.config.enabledGroups)))
            try {
              yield a.track(h(u({}, i), {
                props: u(u({}, i.props), o == null ? void 0 : o[k[a.name]])
              }));
            } catch (c) {
              this.warn(c);
            }
        }))
      );
    });
  }
  trackSession(r) {
    this.runProviders((e) => {
      var o;
      return (o = e.trackSession) == null ? void 0 : o.call(e, r);
    });
  }
  shutdown() {
    this.runProviders((r) => r.shutdown());
  }
  // Analytics must never break a consuming app, so provider failures are isolated and suppressed.
  runProviders(r) {
    this.providers.forEach((e) => {
      try {
        r(e);
      } catch (o) {
        this.warn(o);
      }
    });
  }
  warn(r) {
    this.config.debug && console.warn("[analytics] provider error (suppressed):", r);
  }
}
export {
  G as A,
  b as i,
  w as p,
  E as r
};



// WEBPACK FOOTER //
// ./~/@3plearning/mx-teacher-analytics/dist/analytics-client-D6MIDN55.js